import { Box, Typography } from '@mui/material';
import { Inbox as InboxIcon } from '@mui/icons-material';

/**
 * Componente de estado vazio padronizado
 * 
 * @param {Component} icon - Ícone a ser exibido (padrão: InboxIcon)
 * @param {string} title - Título da mensagem
 * @param {string} message - Descrição detalhada
 * @param {ReactNode} action - Botão ou ação (opcional)
 * 
 * @example
 * <EmptyState 
 *   icon={BusinessIcon}
 *   title="Nenhum local cadastrado"
 *   message="Adicione seu primeiro local para começar"
 *   action={<Button onClick={handleAdd}>Adicionar Local</Button>}
 * />
 */
export default function EmptyState({ 
  icon: Icon = InboxIcon, 
  title, 
  message, 
  action 
}) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={8}
      px={3}
      minHeight={300}
    >
      <Icon 
        sx={{ 
          fontSize: 80, 
          color: 'text.disabled', 
          mb: 2,
          opacity: 0.5 
        }} 
      />
      <Typography 
        variant="h6" 
        mb={1} 
        color="text.secondary"
        fontWeight={500}
      >
        {title}
      </Typography>
      <Typography 
        variant="body2" 
        color="text.secondary" 
        mb={3}
        textAlign="center"
      >
        {message}
      </Typography>
      {action && <Box mt={1}>{action}</Box>}
    </Box>
  );
}
